import { ThemeRoot } from "../features/Theme"
import { NotificationRoot } from "../features/Notification"
import { AuthRoot } from "@/features/Auth"
import AppRoutes from "./router/AppRoutes"
import { WorkspaceRoot } from "@/features/Workspace"

// import TestApp from "./test"


function App() {
  return (
    <NotificationRoot>
      <ThemeRoot>
        <AuthRoot>
          <WorkspaceRoot>
            <AppRoutes/>
          </WorkspaceRoot>
        </AuthRoot>
      </ThemeRoot>
    </NotificationRoot>
  )
}

export default App